export const FINANCING_CATALOG_STORAGE_KEY = 'sqmt_financing_catalogs_v1';

const item = (id, code, label, description = '', sortOrder = 10, colorHex = '#2563eb') => ({
  id,
  code,
  label,
  description,
  sort_order: sortOrder,
  color_hex: colorHex,
  is_active: true,
});

export const DEFAULT_FINANCING_CATALOG_ITEMS = {
  funnel_stage: [
    item(1, 'IDENTIFICADO', 'Identificado', 'Oportunidad identificada', 10, '#6b7280'),
    item(2, 'CONTACTADO', 'Contactado', 'Primer contacto realizado', 20, '#2563eb'),
    item(3, 'EVALUACION', 'Evaluación', 'Evaluación preliminar', 30, '#0ea5e9'),
    item(4, 'DUE_DILIGENCE', 'Due diligence', 'Revisión en profundidad', 40, '#8b5cf6'),
    item(5, 'NEGOCIACION', 'Negociación', 'Negociación activa', 50, '#a855f7'),
    item(6, 'COMPROMETIDO', 'Comprometido', 'Compromiso / term sheet', 60, '#16a34a'),
    item(7, 'CERRADO', 'Cerrado', 'Operación cerrada', 70, '#0d9488'),
    item(8, 'PERDIDO', 'Perdido', 'Oportunidad perdida', 80, '#dc2626'),
  ],
  activity_action: [
    item(1, 'LLAMADA', 'Llamada', '', 10, '#2563eb'),
    item(2, 'EMAIL', 'Email', '', 20, '#0ea5e9'),
    item(3, 'REUNION', 'Reunión', '', 30, '#8b5cf6'),
    item(4, 'PRESENTACION', 'Presentación', '', 40, '#a855f7'),
    item(5, 'SEGUIMIENTO', 'Seguimiento', '', 50, '#16a34a'),
    item(6, 'ENTRADA_RONDA', 'Entrada en ronda', 'Compromiso / entrada con monto y ronda', 60, '#0d9488'),
    item(7, 'OTRO', 'Otro', '', 70, '#6b7280'),
  ],
  activity_status: [
    item(1, 'PROGRAMADA', 'Programada', '', 10, '#2563eb'),
    item(2, 'PENDIENTE', 'Pendiente', '', 20, '#f59e0b'),
    item(3, 'COMPLETA', 'Completa', '', 30, '#16a34a'),
  ],
  investor_type: [
    item(1, 'ANGEL', 'Ángel', 'Inversionista ángel / persona natural', 10, '#2563eb'),
    item(2, 'VC', 'Venture capital', 'Fondo de capital de riesgo', 20, '#8b5cf6'),
    item(3, 'CVC', 'Corporate VC', 'Brazo de inversión corporativo', 30, '#7c3aed'),
    item(4, 'PE', 'Private equity', 'Private equity / buyout', 40, '#a855f7'),
    item(5, 'FAMILY_OFFICE', 'Family office', '', 50, '#0ea5e9'),
    item(6, 'CORPORATE', 'Corporativo estratégico', 'Inversión estratégica (no CVC formal)', 60, '#0d9488'),
    item(7, 'ACCELERATOR', 'Aceleradora / incubadora', '', 70, '#f59e0b'),
    item(8, 'DEBT', 'Deuda / venture debt', '', 80, '#ea580c'),
    item(9, 'OTRO', 'Otro', '', 90, '#6b7280'),
  ],
  investment_stage: [
    item(1, 'PRE_SEED', 'Pre-seed', '', 10, '#6b7280'),
    item(2, 'SEED', 'Seed', '', 20, '#2563eb'),
    item(3, 'SERIES_A', 'Series A', '', 30, '#0ea5e9'),
    item(4, 'SERIES_B', 'Series B', '', 40, '#8b5cf6'),
    item(5, 'GROWTH', 'Growth / late stage', '', 50, '#a855f7'),
    item(6, 'MULTI', 'Multi-etapa', 'Invierte en varias etapas', 60, '#16a34a'),
  ],
  lead_role: [
    item(1, 'LEAD', 'Lead', 'Lidera rondas', 10, '#16a34a'),
    item(2, 'CO_LEAD', 'Co-lead', '', 20, '#2563eb'),
    item(3, 'FOLLOWER', 'Follower / co-invest', 'Sigue a otros leads', 30, '#0ea5e9'),
    item(4, 'FLEXIBLE', 'Flexible', '', 40, '#8b5cf6'),
    item(5, 'NA', 'No aplica', '', 50, '#6b7280'),
  ],
  fund_instrument: [
    item(1, 'SUBSIDIO', 'Subsidio', '', 10, '#2563eb'),
    item(2, 'CREDITO', 'Crédito blando', '', 20, '#0ea5e9'),
    item(3, 'CAPITAL', 'Aporte de capital', '', 30, '#8b5cf6'),
    item(4, 'GARANTIA', 'Garantía', '', 40, '#a855f7'),
    item(5, 'CONCURSO', 'Concurso / convocatoria', '', 50, '#16a34a'),
    item(6, 'OTRO', 'Otro', '', 60, '#6b7280'),
  ],
  contact_role_investor: [
    item(1, 'MANAGING_PARTNER', 'Managing Partner', '', 10),
    item(2, 'GENERAL_PARTNER', 'General Partner (GP)', '', 20),
    item(3, 'PARTNER', 'Partner / Socio', '', 30),
    item(4, 'PRINCIPAL', 'Principal', '', 40),
    item(5, 'VP', 'VP / Vice President', '', 50),
    item(6, 'INVESTMENT_DIRECTOR', 'Director de inversiones', '', 60),
    item(7, 'INVESTMENT_MANAGER', 'Gerente de inversiones', '', 70),
    item(8, 'ASSOCIATE', 'Associate', '', 80),
    item(9, 'ANALYST', 'Analyst', '', 90),
    item(10, 'CEO_FOUNDER', 'CEO / Founder', '', 100),
    item(11, 'CFO', 'CFO', '', 110),
    item(12, 'BOARD', 'Board member / Consejero', '', 120),
    item(13, 'SCOUT', 'Scout', '', 130),
    item(14, 'DEALFLOW', 'Dealflow / Program Manager', '', 140),
    item(15, 'RELATIONSHIP', 'Relationship Manager', '', 150),
    item(16, 'OTRO', 'Otro', '', 160),
  ],
  contact_role_fund: [
    item(1, 'EJECUTIVO', 'Ejecutivo de proyectos', '', 10),
    item(2, 'COORDINADOR', 'Coordinador', '', 20),
    item(3, 'ANALISTA', 'Analista', '', 30),
    item(4, 'JEFE_AREA', 'Jefe de área / unidad', '', 40),
    item(5, 'GERENTE', 'Gerente', '', 50),
    item(6, 'DIRECTOR', 'Director', '', 60),
    item(7, 'EVALUADOR', 'Evaluador', '', 70),
    item(8, 'CONTACTO_INST', 'Contacto institucional', '', 80),
    item(9, 'OTRO', 'Otro', '', 90),
  ],
};

export const loadFinancingCatalogItems = () => {
  try {
    const raw = window.localStorage.getItem(FINANCING_CATALOG_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
};

export const saveFinancingCatalogItems = (itemsByKey) => {
  try {
    window.localStorage.setItem(FINANCING_CATALOG_STORAGE_KEY, JSON.stringify(itemsByKey));
  } catch {
    /* ignore */
  }
};

const activeOptions = (items, key) => {
  const catalog = items != null ? items : loadFinancingCatalogItems() || DEFAULT_FINANCING_CATALOG_ITEMS;
  const list = (catalog && catalog[key]) || DEFAULT_FINANCING_CATALOG_ITEMS[key] || [];
  return list
    .filter((row) => row && row.is_active !== false)
    .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
    .map((row) => ({
      value: row.label || row.code,
      label: row.label || row.code,
      color: row.color_hex,
      code: row.code,
    }));
};

export const getFinancingFunnelStageOptions = (items) => activeOptions(items, 'funnel_stage');
export const getFinancingActivityActionOptions = (items) => activeOptions(items, 'activity_action');
export const getFinancingActivityStatusOptions = (items) => activeOptions(items, 'activity_status');
export const getInvestorTypeOptions = (items) => activeOptions(items, 'investor_type');
export const getInvestmentStageOptions = (items) => activeOptions(items, 'investment_stage');
export const getLeadRoleOptions = (items) => activeOptions(items, 'lead_role');
export const getFundInstrumentOptions = (items) => activeOptions(items, 'fund_instrument');
export const getContactRoleOptions = (kind = 'investor', items) =>
  activeOptions(items, kind === 'fund' ? 'contact_role_fund' : 'contact_role_investor');

export const getFunnelStageColor = (stageLabel, items) => {
  const opts = getFinancingFunnelStageOptions(items);
  const hit = opts.find((o) => o.value === stageLabel || o.label === stageLabel);
  return hit?.color || '#6b7280';
};
